import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";

import {
    LINE_HEIGHT,
    smButtonStyle,
} from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/lead-generator/components/message-strategy/styles";
import { SaveDraftSignalButtonContainer } from "app/pages/sales-intelligence/sub-modules/signals/containers/SaveDraftSignalButton";

export const StyledSaveSignalDraftButton = styled(SaveDraftSignalButtonContainer).attrs({
    iconSize: LINE_HEIGHT,
})`
    ${smButtonStyle};

    ${SWReactIcons}, svg {
        margin-right: 3px;
    }
`;
